export default "<embed src=\"assets/mop.pdf\" width=\"100%\" height=\"900\" alt=\"pdf\">\n"